import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isBetween from 'dayjs/plugin/isBetween'
import duration from 'dayjs/plugin/duration'

dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
dayjs.extend(duration)

export function install (Vue) {
  Vue.prototype.$dayjs = dayjs
}

export default {
  install
}
